// extracted by mini-css-extract-plugin
export default {"container":"Test_container__C7pdO","controls":"Test_controls__CB4uD"};